export const BankAccountDetailsFields = [
  {
    label: "Account Number",
    placeholder: "Account Number",
    name: "BankAccountNo",
    type: "input",
  },
  {
    label: "Account Holder Name",
    placeholder: "Account Holder Name",
    name: "BeneficiaryName",
    type: "input",
  },
  {
    label: "Bank Name",
    placeholder: "Bank Name",
    name: "BankName",
    type: "input",
  },
  {
    label: "IFSC Code",
    placeholder: "IFSC Code",
    name: "IfscCode",
    type: "input",
  },
];

export const BusinessDetailsFields = [
  {
    label: "Business Name",
    placeholder: "Business Name",
    name: "BusinessName",
    type: "input",
  },
  {
    label: "Business Pincode",
    placeholder: "Business Pincode",
    name: "BusinessPincode",
    type: "input",
  },
  {
    label: "Business State",
    placeholder: "Business State",
    name: "BusinessState",
    type: "input",
  },
  {
    label: "Business City",
    placeholder: "Business City",
    name: "BusinessCity",
    type: "input",
  },
  {
    label: "Business Address",
    placeholder: "Business Address (Max 100 characters)",
    name: "BusinessAddress",
    type: "input",
    maxLength: 100,
  },
];

export const DocumentVerificationFields = [
  {
    label: "PAN Card",
    placeholder: "PAN Card",
    name: "PanCard",
    type: "input",
  },
  {
    label: "GST Number",
    placeholder: "GST Number",
    name: "GstNo",
    type: "input",
  },
];

// Legacy export for backward compatibility
export const UpdateUserFinancialDrawerSelectOptions = [
  ...BankAccountDetailsFields,
  ...BusinessDetailsFields,
  ...DocumentVerificationFields,
];
  